export const categories = [
  {
    slug: "zuixin-baoliao",
    name: "最新爆料",
    description: "最新最热的娱乐圈爆料，第一时间掌握明星动态",
    icon: "ri-flashlight-line",
  },
  {
    slug: "mingxing-heiliao",
    name: "明星黑料",
    description: "明星艺人黑历史、不为人知的真实内幕",
    icon: "ri-spy-line",
  },
  {
    slug: "lianqing-gua",
    name: "恋情瓜",
    description: "明星恋情、绯闻、出轨、分手等情感八卦",
    icon: "ri-heart-pulse-line",
  },
  {
    slug: "zongyi-neimu",
    name: "综艺内幕",
    description: "综艺节目幕后真相、选手黑幕、导师内定等",
    icon: "ri-tv-2-line",
  },
  {
    slug: "yingshi-quan",
    name: "影视圈",
    description: "影视剧组内幕、演员片酬、导演潜规则等",
    icon: "ri-film-line",
  },
  {
    slug: "yinle-quan",
    name: "音乐圈",
    description: "音乐圈抄袭、假唱、代写等黑料内幕",
    icon: "ri-music-line",
  },
];